<template>
  <v-card class="flex-grow-1">
    <v-row class="ma-0" @click="details = !details" style="cursor:pointer">
      <v-col
        class="ma-0"
        cols="10"
        style="background-color:#A9A9A9; color:white"
      >
        <span class="ml-2">
          {{ category.Category }}
        </span>
      </v-col>
      <v-col
        cols="2"
        class="d-flex justify-end"
        style="background-color:#A9A9A9; color:white"
      >
        <v-avatar color="primary" size="24">
          {{ category.NumberOfBenefits }}
        </v-avatar>
        <v-spacer></v-spacer>
        <div>
          <v-btn text x-small color="white">
            <v-icon>
              {{ expandIcon }}
            </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-2 mb-0" no-gutters v-if="details">
      <plan-benefit-list
        :category="category.Category"
        :effectiveDate="effectiveDate"
        :planIdentityId="planIdentityId"
        :memberGroupIdentityId="memberGroupIdentityId"
      />
    </v-row>
  </v-card>
</template>

<script>
import PlanBenefitList from "./PlanBenefitList.vue";
export default {
  props: ["category", "planName", "effectiveDate", "planIdentityId", "expanded", "memberGroupIdentityId"],
  components: {
    PlanBenefitList,
  },
  data() {
    return {
      details: false,
    };
  },
  computed: {
    expandIcon() {
      if (this.details) {
        return "keyboard_arrow_up";
      }
      return "keyboard_arrow_down";
    },
  },
  watch: {
    details:{
      handler(v) {
        if (v) {
          this.$emit("expand")
        }
      }
    },
    expanded:{
      handler(v) {
        if (!v) {
          this.details = false;
        }
      }
    }
  },
  methods: {},
};
</script>

<style></style>
